import React, { useState, useRef } from 'react'
import { useResizeObserver } from 'hooks/useResizeObserver'
import { throttle } from 'lodash'

const useWidthResizeThrottle = (
  containerEl: React.RefObject<Element>,
  callBack: () => void,
  wait: number
) => {
  const [throttledWidth, setThrottledWidth] = useState(0)
  const throttledFunc = useRef(
    throttle((newContainerWidth) => {
      setThrottledWidth(newContainerWidth)
      callBack()
    }, wait)
  )

  useResizeObserver(
    containerEl,
    (entries) => {
      const containerElWidth = entries[0].contentRect.width
      if (containerElWidth !== throttledWidth) {
        throttledFunc.current(containerElWidth)
      }
    },
    { skipFirst: true }
  )

  return throttledWidth
}

export default useWidthResizeThrottle
